import React from "react";
import Button from "../Button/Button";
import ErrorIcon from "../../../assets/svg/error-emblem.svg";
import closeIcon from "../../../assets/svg/close-dark.svg";

import "./AddEducationModal.scss";
import { useTranslation } from "react-i18next";
import cs from "classnames";
import AddEducationForm from "./AddEducationForm/AddEducationForm";

interface AddEducationModalProps {
  onCancel: () => void;
  onSubmit: (values: any) => void;
  title?: string;
  buttonLabel: string;
  hideCancelBtn?: boolean;
}

const AddEducationModal = (props: AddEducationModalProps) => {
  const { t } = useTranslation("common");

  return (
    <div className="AddEducationModal">
      <div className="AddEducationModal__container">
        {/*<img*/}
        {/*  className="AddEducationModal__close"*/}
        {/*  alt="close icon"*/}
        {/*  src={closeIcon}*/}
        {/*  onClick={() => {*/}
        {/*    props.onCancel();*/}
        {/*  }}*/}
        {/*/>*/}
        {/*<img src={ErrorIcon} alt="alert icon" className="AddEducationModal__icon" />*/}
        <AddEducationForm
          onCancel={props.onCancel}
          onSubmit={props.onSubmit}
        />
      </div>
    </div>
  );
};

export default AddEducationModal;
